// sessionStorage flag set when an order is placed through the PDP 1-click Apple Pay
// flow. The order confirmation page reads (and clears) it to fire event336 for this
// feature only.
export const APPLE_PAY_PDP_ORDER_KEY = 'applePayPdpOrder';
